import { useParams } from 'react-router-dom';
import { useGetAssessment } from './properties/useGetAssessment';
import { useGetExamQuestions } from './properties/useGetExamQuestions';
import moment from 'moment';
import { Button, Form } from 'react-bootstrap';
import { useState } from 'react';
import { useGetCoursesName } from "./properties/useGetCoursesName";
import { useNavigate } from 'react-router-dom';

export const ExamDetailsComponent = () => {
    const { examId } = useParams<{ examId: string }>();
    const { assessments } = useGetAssessment();
    const { questionsCount } = useGetExamQuestions(examId || '');
    const [acknowledged, setAcknowledged] = useState(false);
    const { getCourseName } = useGetCoursesName();
    const navigate = useNavigate();
    const exam = assessments.find(assessment => assessment.assessmentId === examId);

    if (!exam) {
        return <div>Loading...</div>;
    }

    const currentTime = moment();
    const startTime = moment(exam.starttime);
    const endTime = moment(exam.endtime);
    const isTimeValid = currentTime.isBetween(startTime, endTime);

    const examDuration = moment(exam.endtime).diff(moment(exam.starttime), 'minutes');

    const durationHours = Math.floor(examDuration / 60);
    const durationMinutes = examDuration % 60;
    
    let formattedDuration = `${durationHours} hrs : ${durationMinutes.toString().padStart(2, '0')} mins`;
    
    const handleAcknowledgmentChange = () => {
        setAcknowledged(!acknowledged);
    };

    const handleStartExamClick = () => {
        if (!acknowledged) {
            alert('Please acknowledge the exam instructions before starting the exam.');
            return;
        }

        navigate(`/startexam(${examId})`);
    };

    const handleAbortExamClick = () => {
        window.history.back();
    };

    return (
        <div className="container">
            <h1 className="text-center mt-5" style={{ backgroundColor: 'lightgrey' }}>Exam Details</h1>
            <div className="card p-4 mt-4 d-flex flex-column flex-md-row">

                <div className="col-md-7 mb-4 mb-md-0 pr-md-4" style={{ fontSize: '1.25rem' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '15px', marginTop: '15px' }}>{exam.name}</h2>
                    <div className="mb-2">
                        <strong style={{ minWidth: '200px', display: 'inline-block' }}>Course:</strong>
                        <span>{getCourseName(exam.courseId || '')}</span>
                    </div>
                    <div className="mb-2">
                        <strong style={{ minWidth: '200px', display: 'inline-block' }}>Starting on:</strong>
                        <span>{moment(exam.starttime).format('DD-MM-YYYY HH:mm')}</span>
                    </div>
                    <div className="mb-2">
                        <strong style={{ minWidth: '200px', display: 'inline-block' }}>Expiring on:</strong>
                        <span>{moment(exam.endtime).format('DD-MM-YYYY HH:mm')}</span>
                    </div>
                    <div className="mb-2">
                        <strong style={{ minWidth: '200px', display: 'inline-block' }}>Total Questions:</strong>
                        <span>{questionsCount}</span>
                    </div>
                    <div className="mb-2">
                        <strong style={{ minWidth: '200px', display: 'inline-block' }}>Exam Duration:</strong>
                        <span>{formattedDuration}</span>
                    </div>
                </div>


                <div className="overflow-auto" style={{ backgroundColor: '#f7f7f7', padding: '15px', overflowY: 'auto', maxHeight: '300px', borderRadius: '10px' }}>
                    <h4>Kindly Read the following Instructions:</h4>

                    <p>{exam.instruction || 'No instructions provided'}</p>
                    {/* Acknowledgment Checkbox */}
                    <Form.Group controlId="formBasicCheckbox" className="mt-4">
                        <Form.Check
                            type="checkbox"
                            label="I have read and agree to the exam instructions"
                            checked={acknowledged}
                            onChange={handleAcknowledgmentChange}
                            style={{ borderColor: '#000' }}
                        />
                    </Form.Group>
                </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
                <Button
                    variant="danger"
                    onClick={handleAbortExamClick}
                    style={{ marginRight: '10px' }}
                >
                    Abort Exam
                </Button>
                {isTimeValid && acknowledged ? (
                    <Button
                        style={{ backgroundColor: 'green' }}
                        className="ml-3"
                        onClick={handleStartExamClick}
                    >
                        Start Exam
                    </Button>
                ) : (
                    <Button
                        style={{ backgroundColor: 'grey', borderColor: 'grey', color: 'white', marginRight: '10px' }}
                        className="ml-3"
                        disabled
                    >
                        Start Exam
                    </Button>
                )}
            </div>
        </div>
    );
};
